const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type StoreItem = {
  id: number;
  storeName: string;
  isActive: boolean;
  createdAt: string;
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message =
    typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchStoreList() {
  const response = await fetch(`${apiBaseUrl}/api/admin/stores`);
  await throwIfNotOk(response);
  const payload = (await response.json()) as { stores: StoreItem[] };
  return payload.stores;
}

export async function createStore(input: { storeName: string }) {
  const response = await fetch(`${apiBaseUrl}/api/admin/stores`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
}

export async function deleteStore(storeId: number) {
  const response = await fetch(`${apiBaseUrl}/api/admin/stores/${storeId}`, {
    method: 'DELETE',
  });
  await throwIfNotOk(response);
}
